import { View } from 'foundations-components/transitional/components/View';
import FormattedMessage from 'I18n/components/FormattedMessage';
import SidebarSection from '../components/sidebar/SidebarSection';
import { Text } from 'foundations-components/components/Text';
import { Image } from 'foundations-components/transitional/components/Image';
import { getThemeImageUrl, getThemeName } from '../selectors/themeSelectors';
import { isFulfilled } from '../utils/requestStatus';
import { getDependentPagesRequestStatus, getDependentTemplatesRequestStatus, getGroupedDependentAssetOptionsCount } from '../selectors/themeDependentAssetsSelectors';
import { useSelector } from 'react-redux';
import { Flex } from 'foundations-components/components/Flex';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Button } from 'foundations-components/transitional/components/Button';
import { NextIcon } from 'foundations-assets';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const i18nKey = key => `theme-previewer.themeSettings.universal.${key}`;
const UniversalEditorHeaderContainer = ({
  toggleDependentsPanel
}) => {
  const imageUrl = useSelector(getThemeImageUrl);
  const themeName = useSelector(getThemeName);
  const dependentsCount = useSelector(getGroupedDependentAssetOptionsCount);
  const dependentPagesRequestStatus = useSelector(getDependentPagesRequestStatus);
  const dependentTemplatesRequestStatus = useSelector(getDependentTemplatesRequestStatus);
  const isAssetsReady = isFulfilled(dependentPagesRequestStatus) && isFulfilled(dependentTemplatesRequestStatus);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(View, {
      borderBlockEndStyle: "solid",
      borderBlockEndColor: "border-core-default",
      borderBlockEndWidth: "100",
      children: /*#__PURE__*/_jsxs(SidebarSection, {
        children: [/*#__PURE__*/_jsx(View, {
          marginBlockStart: "200",
          children: /*#__PURE__*/_jsx(Text, {
            as: "h5",
            marginBlockEnd: "0",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18nKey('header')
            })
          })
        }), /*#__PURE__*/_jsx(View, {
          paddingBlockStart: "100",
          as: "div",
          children: /*#__PURE__*/_jsx(Text, {
            as: "small",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18nKey('helpText')
            })
          })
        })]
      })
    }), /*#__PURE__*/_jsx(View, {
      borderBlockEndStyle: "solid",
      borderBlockEndColor: "border-core-default",
      borderBlockEndWidth: "100",
      paddingBlock: "600",
      paddingInlineStart: "400",
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(Image, {
          blockSize: "80px",
          inlineSize: "106px",
          responsive: false,
          objectFit: "cover",
          src: imageUrl || '',
          paddingInlineEnd: "100"
        }), /*#__PURE__*/_jsxs(Flex, {
          flexDirection: "column",
          children: [/*#__PURE__*/_jsx(Text, {
            as: "h6",
            truncate: true,
            children: themeName
          }), isAssetsReady && /*#__PURE__*/_jsx(Flex, {
            flexDirection: "column",
            paddingBlockStart: "200",
            children: /*#__PURE__*/_jsx(Text, {
              typography: "detail-100",
              children: /*#__PURE__*/_jsxs(Button, {
                use: "link",
                onClick: toggleDependentsPanel,
                children: [/*#__PURE__*/_jsx(FormattedMessage, {
                  message: i18nKey('assets'),
                  options: {
                    count: dependentsCount
                  }
                }), /*#__PURE__*/_jsx(IconHolder, {
                  icon: NextIcon,
                  padding: "0"
                })]
              })
            })
          }), !isAssetsReady && /*#__PURE__*/_jsx(LoadingSpinner, {
            size: "extra-small",
            grow: true
          })]
        })]
      })
    })]
  });
};
export default UniversalEditorHeaderContainer;